import * as React from "react";
import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";
import { PostCodeAnywhereSearchEditor } from "../../../../../../../react-core/Html/Address/PostCodeAnywhereSearchEditor";
import { CountryCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CountryCode";
import { TextBoxEditor } from "../../../../../../../react-core/Html/TextBoxEditor";
import { Address } from "../../../../../../../Wrap/Models/Domains/Address/Address";
import { UkPostCode } from "../../../../../../../react-core/Html/Validation/RegExPatterns";

interface IBankAddressProps extends React.Props<BankAddress> {
    address: Address;
    onChange: (v: Address) => void;
    onRef: (v) => void;
    isReview?: boolean;
    notRequired?: boolean;
}

interface IBankAddressState {}

export class BankAddress extends FormComponent<IBankAddressProps, IBankAddressState> {
    constructor(props: any) {
        super(props);
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    private onAddressChange(changes) {
        let { address } = this.props;
        if (!address) {
            address = this.emptyAddress();
        }
        for (const key in changes) {
            address[key] = changes[key];
        }
        this.props.onChange(JSON.parse(JSON.stringify(address)));
    }

    render() {
        const { isReview } = this.props;
        const { address } = this.props;
        const required = !this.props.notRequired;
        return (
            <>
                <PostCodeAnywhereSearchEditor
                    onLookupError={() => {}}
                    onAddressSelected={(v) => {
                        this.props.onChange({
                            Line1: v.Line1,
                            Line2: v.Line2,
                            Line3: v.Line3,
                            Line4: v.Line4,
                            Postcode: v.Postcode,
                        });
                    }}
                    countryCode={CountryCode.GBR}
                    label={`Post code:${required ? "*" : ""}`}
                    disabled={isReview}
                />
                <br />
                <TextBoxEditor
                    disabled={isReview}
                    label={`Address line 1:${required ? "*" : ""}`}
                    value={address?.Line1}
                    required={required ? "Please enter address line 1" : null}
                    onChange={(v) => this.onAddressChange({ Line1: v })}
                />
                <TextBoxEditor
                    disabled={isReview}
                    label={`Address Line2:${required ? "*" : ""}`}
                    value={address?.Line2}
                    required={required ? "Please enter address line 2" : null}
                    onChange={(v) => this.onAddressChange({ Line2: v })}
                />
                <TextBoxEditor
                    disabled={isReview}
                    label="Address line 3:"
                    value={address?.Line3}
                    maxLength={35}
                    onChange={(v) => this.onAddressChange({ Line3: v })}
                />
                <TextBoxEditor
                    disabled={isReview}
                    label="Address line 4:"
                    value={address?.Line4}
                    onChange={(v) => this.onAddressChange({ Line4: v })}
                />
                <TextBoxEditor
                    disabled={isReview}
                    label="Postcode:*"
                    value={address?.Postcode}
                    required={"Please enter postcode"}
                    regex={{ errorMessage: "Please enter valid postcode", value: UkPostCode }}
                    onChange={(v) => this.onAddressChange({ Postcode: v })}
                />
            </>
        );
    }
    private emptyAddress(): Address {
        return { Line1: null, Line2: null, Line3: null, Line4: null, Postcode: null };
    }
}
